<template>
  <el-card class="box-card">
    <el-row class="fs-bd-b pb-2">
      <!-- <el-col :span="16" v-if="upcominglist.flagEditOrder"> -->
      <el-col :span="12" v-if="((upcominglist.deliveryStatus == 3 || upcominglist.deliveryStatus == 9) && upcominglist.paymentType == 1 && upcominglist.confirmEditFlag == 0 && upcominglist.editType != 1) || ((upcominglist.deliveryStatus == 3 || upcominglist.deliveryStatus == 9) && upcominglist.paymentType == 2 && upcominglist.confirmEditFlag == 0 && upcominglist.editType != 1)">
        <!-- <h3>ออเดอร์ #{{ upcominglist.orderCode }} | {{ upcominglist.paymentType }}</h3> -->
        <p class="text-heading2--med ma--0">{{ $t('drawer.editorder.order') }} #{{ upcominglist.orderCode }}</p>
        <i class="fs-warning text-subtitle--med el-icon-warning-outline"></i> 
        <label class="fs-warning text-subtitle--med" v-html="$t('pageOrderListCurrent.editheader')"></label>
      </el-col>
      <el-col :span="12" v-else>
        <p class="text-heading2--med ma--0">{{ $t('drawer.editorder.order') }} #{{ upcominglist.orderCode }}</p>
        <label class="fs-link text-heading3--bold" v-if="upcominglist.deliveryStatus == 1">{{ $t('pageOrderListCurrent.waitconfirmorder') }}</label>
        <label class="fs-link text-heading3--bold" v-if="upcominglist.deliveryStatus == 2">{{ $t('pageOrderListCurrent.prepairorder') }}</label>
        <label class="fs-link text-heading3--bold" v-if="upcominglist.deliveryStatus == 5 || upcominglist.deliveryStatus == 7">{{ $t('pageOrderListCurrent.orderalready') }}</label>
        <label class="fs-link text-heading3--bold" v-if="upcominglist.deliveryStatus == 9">{{ $t('pageOrderListCurrent.confirmorder') }}</label>
        <label class="fs-wait text-heading3--bold" v-if="upcominglist.deliveryStatus == 8 && upcominglist.isPaid == 0">{{ $t('pageOrderListCurrent.waitpayment') }}</label>
      </el-col>
      <!-- Wait Confirm Slip -->
      <el-col v-if="upcominglist.slipStatus" :span="12" class="text-right">
        <BaseButton class="fs-btn-border-wn py--1" @click="toggle_bank_account_detail(index, upcominglist)">{{ $t('pageOrderListCurrent.recheckslip') }}</BaseButton>
      </el-col>
      <!-- Confirm Payment QR -->
      <el-col v-if="upcominglist.isPaid == 0 && upcominglist.confirmEditFlag == 0 && upcominglist.paymentType == 17 && !upcominglist.slipStatus" :span="12" class="text-right">
        <BaseButton class="fs-btn-border py--1" @click="redirectPayment(upcominglist)">{{ $t('drawer.editorder.payment') }}</BaseButton>
      </el-col>
      <!-- Confirm Payment Transfer -->
      <el-col v-if="upcominglist.isPaid == 0 && (upcominglist.deliveryStatus != 3 && upcominglist.deliveryStatus != 9) && upcominglist.paymentType == 2 && !upcominglist.slipStatus" :span="12" class="text-right">
        <BaseButton class="fs-btn-border py--1" @click="toggle_bank_account_detail(index, upcominglist)">{{ $t('drawer.editorder.payment') }}</BaseButton>
      </el-col>
      <!-- Case Edit Order Preorder -->
      <el-col v-if="upcominglist.isPaid == 0 && upcominglist.deliveryStatus == 9 && upcominglist.paymentType == 2 && upcominglist.confirmEditFlag == 1 && !upcominglist.slipStatus" :span="12" class="text-right">
        <BaseButton class="fs-btn-border py--1" @click="toggle_bank_account_detail(index, upcominglist)">{{ $t('drawer.editorder.payment') }}</BaseButton>
      </el-col>
      <el-col v-if="upcominglist.isPaid == 0 && upcominglist.deliveryStatus == 9 && upcominglist.paymentType == 2 && upcominglist.confirmEditFlag == 0 && upcominglist.editType == 1 && !upcominglist.slipStatus" :span="12" class="text-right">
        <BaseButton class="fs-btn-border py--1" @click="toggle_bank_account_detail(index, upcominglist)">{{ $t('drawer.editorder.payment') }}</BaseButton>
      </el-col>
      <el-col v-if="upcominglist.deliveryStatus == 9 && upcominglist.confirmEditFlag == 0 && upcominglist.editType == 3 && !upcominglist.slipStatus" :span="12" class="text-right">
        <BaseButton class="fs-btn-border-wn py--1" @click="confirmEditOrder(index)">{{ $t('drawer.editorder.payment') }}</BaseButton>
      </el-col>
      <!-- Confirm Edit Order -->
      <el-col v-if="upcominglist.isPaid == 1 && upcominglist.confirmEditFlag == 1 && Number(upcominglist.origTotalAmount) < Number(upcominglist.totalAmount) && upcominglist.paymentType == 2 && upcominglist.refundStatus == 0 && !upcominglist.slipStatus" :span="12" class="text-right">
        <BaseButton class="fs-btn-border py--1" @click="toggle_bank_account_detail(index, upcominglist)">{{ $t('drawer.editorder.payment') }}</BaseButton>
      </el-col>
      <el-col v-if="upcominglist.deliveryStatus == 3 && upcominglist.confirmEditFlag == 0 && upcominglist.editType != 2 && (upcominglist.paymentType == 1 || upcominglist.paymentType == 2) && !upcominglist.slipStatus" :span="12" class="text-right">
        <BaseButton class="fs-btn-border-wn py--1" @click="confirmEditOrder(index)">{{ $t('dialog.confirm') }}</BaseButton>
      </el-col>
    </el-row>
    <el-row>
      <el-col class="mt-2 fs-of-address" v-if="upcominglist.orderTypeDesc == 'Delivery'">
        <label class="text-heading3--bold cl-gray-ligth">
          <i class="fs-16 el-icon-location"></i> {{ $t('pageOrderListHistory.delivery') }}
        </label>
        <label class="text-heading3 ml--2">{{ upcominglist.address }}</label>
      </el-col>
      <el-col class="mt-2 fs-of-address" v-else>
        <img width="20" src="@/assets/icons/pickup_inactive.png"/>
        <label class="text-heading3--bold cl-gray-ligth">{{ $t('pageOrderListHistory.pickup') }}</label>
        <label class="text-heading3 ml--2" v-if="upcominglist.branchName == '' || upcominglist.branchName === null">{{ upcominglist.restaurantName }}</label>
        <label class="text-heading3 ml--2" v-else>{{ upcominglist.restaurantName }} {{ $t('pageCheckout.branch') }} {{ upcominglist.branchName }}</label>
      </el-col>
      <!-- Preorder Time -->
      <el-col v-if="upcominglist.isPreorder">
        <label class="text-heading3--bold cl-gray-ligth"><i class="el-icon-time fw-lg fs-16"></i> {{ (upcominglist.orderTypeDesc == 'Delivery') ? $t('pageCheckout.deliverytime') : $t('pageCheckout.pickuptime') }}</label>
        <label class="text-heading3 ml--2"> {{ (isToday(upcominglist.orderedTime.date)) ? this.$t('dialog.preorder.today') + ', ' + upcominglist.orderedTime.date : ($i18n.locale === 'en') ? this.filter_long_day_en(upcominglist.orderedTime.dayList) + ', ' + upcominglist.orderedTime.date : this.filter_long_day_th(upcominglist.orderedTime.dayList) + ', ' + upcominglist.orderedTime.date }} </label>
      </el-col>
      <!-- Order Now -->
      <el-col v-else>
        <label class="text-heading3--bold cl-gray-ligth"><i class="el-icon-time fw-lg fs-16"></i> {{ (upcominglist.orderTypeDesc == 'Delivery') ? $t('pageCheckout.deliverytime') : $t('pageCheckout.pickuptime') }}</label>
        <label class="text-heading3 ml--2" v-if="upcominglist.estimatedTime == 0"> {{ $t('pageCheckout.deliverynow') }}</label>
        <label class="text-heading3 ml--2" v-else> {{ $t('pageCheckout.deliverynow') }} ({{ $t('pageOrderListCurrent.around') }} {{ upcominglist.estimatedTime }} {{ $t('pageOrderListCurrent.minute') }}) </label>
      </el-col>
      <el-col class="fs-image-icon fs-bd-b py-1">
        <el-row>
          <el-col v-bind:class="(index == 4) ? '' : 'mr-14'" v-for="(menu, index) in upcominglist.menus" :key="index" :span="4">
            <el-image
            v-if="index < 4"
            class="image"
            :fit="'cover'"
            :src="'https://images.foodstory.co/' + menu.image_key"
            :preview-src-list="srcList"
            :alt="'menu-detail'"></el-image>
            <div v-if="index == 4" class="fs-image-icon-more" @click="viewMoreImgae(upcominglist.menus)">
              <span>+{{ upcominglist.menus.length }}</span>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col>
        <el-row class="py-1">
          <el-col :span="12" class="text-left">
            <label class="text-title--large">
              {{ $t('pageCheckout.subtotal') }}:
              {{ upcominglist.totalAmount | priceFormat(0,$store.getters.currency) }}
            </label>
          </el-col>
          <el-col :span="12" class="text-right">
            <label class="fs-link text-link" @click="goToPaid">{{ $t('pageOrderListCurrent.moredetail') }}</label>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import Mixins from '@/utils/mixins'
export default {
  name: 'OrderListCurrent',
  props: ['restaurant_uuid', 'branch_uuid', 'upcominglist', 'index'],
  data () {
    return {
      srcList: []
    }
  },
  mixins: [Mixins],
  mounted () {
    this.srcList = []
    this.upcominglist.menus.forEach(element => {
      this.srcList.push('https://images.foodstory.co/' + element.image_key)
    })
  },
  methods: {
    viewMoreImgae (menu) {
      this.srcList = []
      menu.forEach(element => {
        this.srcList.push('https://images.foodstory.co/' + element.image_key)
      })
      this.$emit('toggle_all_image', this.srcList)
    },
    togglePaid () {
      this.$emit('toggle_piad', this.upcominglist)
    },
    async goToPaid () {
      await this.$store.dispatch('startLoading')
      this.$router.push({ path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}/confirmorder`, query: { oid: this.upcominglist.orderId } })
    },
    async redirectPayment (order) {
      const loading = await this.$store.dispatch('startLoading')
      setTimeout(() => {
        loading.close()
      }, 2000)
      if (order.paymentType == 17) {
        this.$store.dispatch('recheckQRPayment', { rcp: order.orderCode, unq: order.uniqueOrderCode, uid: order.branchUUID }).then((response) => {
          if (response) {
            this.$router.go(0)
          } else {
            this.$router.push({ path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}/qr`, query: { 'rcp': order.orderCode, 'unq': order.uniqueOrderCode, 'uid': order.branchUUID } })
          }
        })
      } else {
        this.$router.push({ path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}/confirmorder`, query: { oid: this.upcominglist.orderId } })
      }
    },
    toggle_bank_account_detail (index, upcoming) {
      this.$emit('toggle_bank_account_detail', { type: 'upcoming', index: index, upcoming: upcoming })
    },
    confirmEditOrder (index) {
      this.$store.dispatch('setConfirmEditOrder', {
        restaurant_uuid: this.BranchDetail.restaurantId,
        branch_uuid: this.BranchDetail.id,
        orderId: this.upcominglist.orderId
      }).then((response) => {
        if(response) {
          this.$emit('toggle_confirm_from_list_order', { status: true, index: index })
        } else {
          this.$emit('toggle_confirm_from_list_order', { status: false, index: index })
        }
      })
    }
  },
  computed: {
    BranchDetail () {
      return this.$store.getters.BranchDetail
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/order/OrderListCurrent.vue